module.exports = __webpack_public_path__ + "officialStatic/img/n6.7650d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n6.png
// module id = KIcs
// module chunks = 0